module.exports = __webpack_public_path__ + "static/img/智慧农业展厅.c5b90052.png";